import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Helmet from "react-helmet";

const CustomHeadElements = () => {
  const {
    home: {
      domain: { market },
    },
  } = useStaticQuery(graphql`
    query {
      home {
        domain {
          market
        }
      }
    }
  `);

  switch (market) {
    case "ru":
      return (
        <Helmet>
          <meta name="yandex-verification" content="7d9c0eac696dd8bb" />
        </Helmet>
      );

    default:
      return null;
  }
};

export default CustomHeadElements;
